
export enum ChargingType {
  PlugInAC= 'PlugInAC',
  PlugInDC= 'PlugInDC',
  PantographCharger= 'PantographCharger',
  Induction= 'Induction',
  BatterySwapping= 'BatterySwapping',

}